// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T6I6","option":"styles_option__3cmZl","active":"styles_active__3UNx5"};